import { memo } from 'react';

import { Sync } from '@air/next-icons';

export const FileStatusIconProgressing = memo(() => {
  return (
    <div
      aria-hidden
      className="mr-3 flex size-10 animate-spin items-center justify-center rounded-full bg-sky-5 motion-reduce:animate-none"
    >
      <Sync className="size-6 text-sky-11" />
    </div>
  );
});

FileStatusIconProgressing.displayName = 'FileStatusIconProgressing';
